import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import ReactFlow, {Controls, PanOnScrollMode, ReactFlowInstance} from 'reactflow';

import AddSourceStepButton from 'analysis-tool/ui/AddSourceStepButton';
import {REACT_FLOW_PRO_OPTIONS} from 'processes/graph-builder/ReactFlowConstants';

import {
  AnalysisGraph,
  AnalysisGraphEdgeType,
  AnalysisGraphNodeType,
} from './analysis-graph/AnalysisGraphTypes';
import AnalysisFlowchartEdge from './AnalysisFlowchartEdge';
import AnalysisFlowchartNode from './AnalysisFlowchartNode';

const STATIC_PROPS: Partial<Parameters<typeof ReactFlow>[0]> = {
  connectOnClick: false,
  edgesFocusable: false,
  fitView: true,
  fitViewOptions: {padding: 0.2, minZoom: 0.5, maxZoom: 2},
  nodesConnectable: false,
  nodesDraggable: false,
  nodesFocusable: false,
  onInit: (reactFlowInstance: ReactFlowInstance) => {
    reactFlowInstance.fitView();
  },
  panOnScroll: true,
  panOnScrollMode: PanOnScrollMode.Vertical,
  panOnDrag: true,
  proOptions: REACT_FLOW_PRO_OPTIONS,
  selectionKeyCode: null,
  selectNodesOnDrag: false,
};

const EDGE_TYPES = {[AnalysisGraphEdgeType.EDGE]: AnalysisFlowchartEdge};
const NODE_TYPES = {[AnalysisGraphNodeType.STEP]: AnalysisFlowchartNode};

/**
 * Internal helper component for `AnalysisFlowchart`, which assumes `ReactFlowProvider` and
 * `AnalysisFlowchartContext` contexts are available.
 *
 * @package
 */
export default function InternalAnalysisFlowchart({nodes, edges}: AnalysisGraph): JSX.Element {
  return (
    <ReactFlow nodes={nodes} edges={edges} edgeTypes={EDGE_TYPES} nodeTypes={NODE_TYPES} {...STATIC_PROPS}>
      <div className={css(styles.createNodeButtonPositioningWrapper)}>
        <div className={css(styles.createNodeButton)}>
          <AddSourceStepButton />
        </div>
      </div>
      <Controls className={css(styles.controls)} showInteractive={false} />
    </ReactFlow>
  );
}

const styles = StyleSheet.create({
  controls: {bottom: '60px', left: '1px'},
  createNodeButtonPositioningWrapper: {position: 'absolute', top: '12px', right: '12px'},
  // ReactFlow uses a z-index of 4 for it's flowchart, so to overlay the create button it must be >= 4
  createNodeButton: {position: 'relative', zIndex: 4},
});
